import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const ANSWERS_ID = ['answer1', 'answer2', 'answer3']
const SLIDER = ['question', ...ANSWERS_ID]
const MAX_LENGTH = 250

const createQuestionRandom = () => {
  function getRandomInt(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  fetch('https://opentdb.com/api.php?amount=1')
    .then((r) => r.json())
    .then((data) => {
      const { question, correct_answer, incorrect_answers } = data.results[0]
      document.getElementsByClassName('mina--textarea')[0].value = question

      let rndAnswerPosition = getRandomInt(1, 3)

      for (let i = 1; i <= 3; i++) {
        if (i === rndAnswerPosition) {
          document.getElementById(`answer${i}`).checked = true
          document.getElementById(`answer${i}-text`).value = correct_answer
        } else {
          document.getElementById(`answer${i}-text`).value = incorrect_answers[i - 1]
        }
      }
    })
    .catch((e) => console.log(e))
}
/**
 *  Pop up showed when you have finished the game
 */
class CreateQuestion extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      focused: '',
      created: false,
      question: '',
      inputElements: 0,
      allElements: {},
      missingParameter: '',
      currentInput: 0,
    }

    this.handleInputChange = this.handleInputChange.bind(this)
  }

  sendQuestion() {
    const elements = this.form
    const { createQuestion } = this.props
    const { created } = this.state
    const completed = this.isCompleted()

    if (!created && completed) {
      this.setState({ created: true })

      let answers = ANSWERS_ID.map((id) => {
        return {
          text: elements[`${id}-text`].value,
          isCorrect: elements['correct'].value == id ? true : false,
        }
      })

      completed && createQuestion({ question: elements['question'].value, choices: answers })
    }
  }

  isCompleted() {
    const elements = this.form
    let completed = true
    if (!elements) {
      return false
    }
    ANSWERS_ID.map((id) => {
      if (
        !elements[`${id}-text`].value ||
        !elements['correct'].value ||
        !elements['question'].value
      ) {
        completed = false
      }
    })

    return completed
  }
  createRandomQuestion(e) {
    const { createQuestion } = this.props

    e.preventDefault()
    e.stopPropagation()

    let answers = ANSWERS_ID.map((id) => {
      return {
        text: id + Math.trunc(Math.random() * 1000),
        isCorrect: 'answer2' == id ? true : false,
      }
    })

    createQuestion({ question: `pregunta${Math.trunc(Math.random())}`, choices: answers })
  }
  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      missingParameter: '',
    })
    if (this.validate(event)) {
      this.setState({ missingParameter: '' })
    }
  }
  validate(e) {
    const { inputElements, allElements } = this.state
    let validation = false
    let updatedCounterElements = inputElements
    if (e.target.value !== '') {
      updatedCounterElements++
      this.setState({ inputElements: updatedCounterElements })
      if (Object.keys(allElements).length > 2) {
        validation = true
      }
    }
    return validation
  }

  checkErrors() {
    const elements = this.form
    let answ_err = {}
    ANSWERS_ID.map((id) =>
      !elements[`${id}-text`].value ? (answ_err[id] = true) : (answ_err[id] = false)
    )

    if (!elements['question'].value) {
      this.setState({ missingParameter: 'question' })
    } else if (Object.values(answ_err).find((a) => a == true)) {
      let first_wrong = Object.keys(answ_err).find((k) => answ_err[k] == true)
      this.setState({ missingParameter: first_wrong })
    } else if (!elements['correct'].value) {
      this.setState({ missingParameter: 'correct' })
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.isCompleted()) {
      this.sendQuestion()
    } else {
      this.checkErrors()
    }
  }
  showInput(input) {
    const { isPortable } = this.props
    const { currentInput } = this.state

    return isPortable ? SLIDER[currentInput] == input : true
  }

  selectInput(selected) {
    const { currentInput } = this.state
    const nextInput = currentInput + selected

    if (nextInput >= 0 && nextInput < 4) {
      this.setState({ currentInput: nextInput })
    }
  }

  renderSlider() {
    const { currentInput } = this.state

    return (
      <div className="mina--buttons paginator">
        <div className={`btn--shape shape--orange ${currentInput - 1 < 0 ? 'disabled' : ''}`}>
          <div onClick={() => this.selectInput(-1)} className="btn--shape__canvas">
            <span className="icon-arrow-left"></span>
          </div>
        </div>
        <div
          onClick={() => this.selectInput(1)}
          className={`btn--shape shape--orange ${currentInput + 1 > 3 ? 'disabled' : ''}`}
        >
          <div className="btn--shape__canvas">
            <span className="icon-arrow-right"></span>
          </div>
        </div>
      </div>
    )
  }

  renderInputs() {
    const { intl } = this.props
    const { focused, allElements, missingParameter } = this.state
    const elements = this.form

    return (
      <React.Fragment>
        <div
          className={` ${!this.showInput('question') ? 'display--none' : 'mina--block'}
            ${focused == 'mina--textarea' ? 'active' : ''} ${
            missingParameter == 'question' ? 'failed' : ''
          }`}
        >
          <textarea
            className="mina--textarea"
            id="question"
            name="question"
            maxLength={MAX_LENGTH}
            placeholder={intl.formatMessage({ id: 'questions.questionPlaceHolder' })}
            onFocus={() => {
              this.setState({ focused: 'mina--textarea', missingParameter: '' })
            }}
            onBlur={() => {
              this.setState({ focused: '' })
              this.handleInputChange
            }}
            onClick={() => {
              !allElements['question'] ? (allElements['question'] = true) : allElements
            }}
            style={{
              fontSize: this.state.question.length > 80 ? '1.25rem' : '1.75rem',
            }}
          />
          <div className="mina--caracteres">
            {MAX_LENGTH - (elements ? elements['question'].value.length : 0)}
          </div>
        </div>
        {ANSWERS_ID.map((a) => (
          <div
            key={a}
            className={`${!this.showInput(a) ? 'display--none' : 'mina--block'}
              ${focused == `${a}-text` ? 'active' : ''} ${missingParameter == a ? 'failed' : ''}`}
            onClick={() => {
              this.setState({ focused: `${a}-text` })
              !allElements[a] ? (allElements[a] = true) : allElements
            }}
          >
            <div className="radiobutton">
              <input id={a} name="correct" value={a} type="radio" autoComplete="off" />
              <label htmlFor={a}></label>
            </div>
            <input
              onBlur={() => {
                this.setState({ focused: '' })
              }}
              onFocus={this.handleInputChange}
              type="text"
              maxLength={MAX_LENGTH}
              key={`${a}-text`}
              id={`${a}-text`}
              name={`${a}-text`}
              placeholder={intl.formatMessage({ id: 'questions.answerPlaceholder' })}
            />
            <div className="mina--caracteres">
              {MAX_LENGTH - (elements ? elements[`${a}-text`].value.length : 0)}
            </div>
          </div>
        ))}
      </React.Fragment>
    )
  }

  render() {
    const { isCreatePenalized, prizeCoins, loading, isPortable } = this.props
    const { missingParameter } = this.state

    return (
      <form
        autoComplete="off"
        onSubmit={(e) => this.handleSubmit(e)}
        ref={(form) => (this.form = form)}
        className=" mina--layer questions growIn-animation"
      >
        <div className="mina--message">
          <div>
            <span className="value">
              <span>
                <FormattedMessage id={'questions.for'} />
              </span>
              {prizeCoins}
              <span className="icon-coin" /> :
            </span>
            <span>
              {' '}
              <FormattedMessage id={'questions.createYourQ'} />
            </span>
          </div>
          <div className="amount">
            {isCreatePenalized && (
              <p>
                <FormattedMessage id="questions.penalized" defaultMessage="Penalized" />
              </p>
            )}
          </div>
        </div>
        {this.renderInputs()}
        {missingParameter != '' && (
          <div className="alert--error shake-animation">
            <FormattedMessage
              id={`questions.create.alert.${
                missingParameter.includes('answer') ? 'answer' : missingParameter
              }`}
            />
          </div>
        )}
        {isPortable ? this.renderSlider() : null}
        <div
          type="submit"
          className={`mina--buttons ${isPortable && this.isCompleted() ? '' : 'disabled'}`}
        >
          <button type="submit" className="btn--orange">
            <span className="icon-planet"></span>
            <span>
              <FormattedMessage id="questions.continue" />
            </span>
          </button>
          {loading && (
            <div className="loader min">
              <div className="loader--item">
                <span className="icon-hex-border"></span>
                <span className="icon-rocket-loading"> </span>
              </div>
            </div>
          )}
        </div>
        {process.env.SKIP_QUESTION ? (
          <button
            onClick={(e) => this.createRandomQuestion(e)}
            type="button"
            className="btn--orange"
          >
            <span className="icon-planet"></span>
            <span>enviar sin más</span>
          </button>
        ) : null}

        {process.env.SKIP_QUESTION ? (
          <button onClick={createQuestionRandom} type="button" className="btn--orange">
            <span className="icon-planet"></span>
            <span>Generar al azar</span>
          </button>
        ) : null}
      </form>
    )
  }
}

CreateQuestion.propTypes = {
  createQuestion: PropTypes.func,
  prizeCoins: PropTypes.number,
  isCreatePenalized: PropTypes.bool,
  loading: PropTypes.bool,
  isPortable: PropTypes.bool,
}

export default CreateQuestion
